import React, { useCallback, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Box } from '@mui/material';
import FileViewer from 'react-file-viewer';
import { ClockLoader } from 'react-spinners';
import { saveAs } from 'file-saver';
import AxiosInstance from '../../server/AxioInstance';
import { useDialog } from '../../shared/context';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DOCUMENT_TYPES = {
  PDF: 'application/pdf',
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  POWERPOINT: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  POWERPOINT_MACRO: 'application/vnd.ms-powerpoint.presentation.macroenabled.12'
};

const ViewDocumentDialog = ({ handleClose, handleCancel, dialogData }) => {
  const reprovedDocumentDialog = useDialog('viewDocumentDialog');
  const [fileContent, setFileContent] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [fileUrl, setFileUrl] = useState(null); // URL para abrir em nova aba

  const { document_type, filename, originalname } = dialogData.item;

  const getMimeType = (mimeType) => {
    switch (mimeType) {
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return 'docx';
      case 'application/pdf':
        return 'pdf';
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      case 'application/vnd.ms-powerpoint.presentation.macroenabled.12':
        return 'pptx';
      case 'text/csv':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return 'xlsx';
      default:
        return 'upload';
    }
  };

  const handleDownload = async () => {
    setButtonDisabled(true);
    try {
      const mimeType = getMimeType(document_type);
      const response = await AxiosInstance.get(`/document/${mimeType}/${filename}`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data]);
      saveAs(blob, originalname);
      console.log('Download do arquivo bem-sucedido!');
    } catch (error) {
      console.error('Erro ao fazer download do arquivo:', error);
      alert('Erro ao fazer o download do arquivo. Por favor, tente novamente mais tarde.');
    } finally {
      setButtonDisabled(false);
      handleClose();
    }
  };

  const fetchFile = useCallback(async () => {
    try {
      const mimeType = getMimeType(document_type);
      const response = await AxiosInstance.get(`/document/${mimeType}/${filename}`, {
        responseType: 'arraybuffer'
      });
      setFile(response.data);
      const blob = new Blob([response.data], { type: mimeType });
      const url = URL.createObjectURL(blob);
      setFileContent(url);
      setFileUrl(url); // Armazena a URL para abrir em nova aba
      setLoading(false);
    } catch (error) {
      console.error('Erro ao buscar o arquivo:', error);
      setLoading(false);
    }
  }, [document_type, filename]);

  const fetchlogview = useCallback(async () => {
    try {
      console.log('view');
      const data = { ...dialogData.item, user: localStorage.getItem('@gedy:user') };
      const result = await AxiosInstance.post('/manipulate-documents/insert-log-view-document', data);
      console.log(result.data);
    } catch (error) {
      console.log('erro: ', error);
    }
  }, [dialogData]);

  useEffect(() => {
    fetchFile();
    fetchlogview();
  }, [fetchFile, fetchlogview]);

  return (
    <Dialog
      open={reprovedDocumentDialog.isDialogOpen()}
      TransitionComponent={Transition}
      keepMounted
      onClose={reprovedDocumentDialog.closeDialog}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle sx={{ fontSize: '2em' }}>{"Visualizar documento"}</DialogTitle>
      {loading ? (
        <center>
          <ClockLoader size={150} color={'#123abc'} loading={loading} />
        </center>
      ) : (
        <Box marginLeft={2} id='file-id'>
          <FileViewer
            fileType={getMimeType(document_type)}
            filePath={fileContent}
            supportedViewers={['pdf', 'doc', 'docx', 'pptm', 'pptx', 'xls', 'xlsx', 'jpeg', 'png', 'gif', 'bmp']}
          />
          {file && (
            [DOCUMENT_TYPES.EXCEL, DOCUMENT_TYPES.POWERPOINT, DOCUMENT_TYPES.POWERPOINT_MACRO].includes(document_type) && (
              <h2>Este arquivo está em um formato que não poderá ser exibido. Por favor, clique no botão de download para baixá-lo.</h2>
            )
          )}
        </Box>
      )}
      <DialogActions>
        <Button variant="outlined" onClick={handleCancel}>
          Fechar
        </Button>
        {file && document_type === DOCUMENT_TYPES.PDF && fileUrl && (
          <Button variant="contained" color="primary" onClick={handleDownload}>
            download
          </Button>
        )}
        {file && document_type === DOCUMENT_TYPES.PDF && fileUrl && (
          [DOCUMENT_TYPES.EXCEL, DOCUMENT_TYPES.POWERPOINT, DOCUMENT_TYPES.POWERPOINT_MACRO].includes(document_type) && (
            <Button variant="contained" color="success" onClick={handleDownload} disabled={buttonDisabled}>
              Download
            </Button>
          )
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ViewDocumentDialog;
